import React, {useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoService from "../../services/EstacionamientoService"

import { useNavigate, NavLink, Navigate } from "react-router-dom";

export default function IndicadorCredito  ()  {
    const [loadingCredit, setLoadingCredit] = useState(false);
    const [availableCredit, setAvailableCredit] = useState("");
    EstacionamientoService.login("1120316456","test1234","48D7F6346A1FA9950C208468C62E5260B6DFE04D873E2D1081D42B763DC746CB")
        .then((resp) => { setAvailableCredit(resp.data.saldoString); })
        .catch((error) => { setAvailableCredit("Error");});
    setLoadingCredit(true);

    return (
        (loadingCredit)?"loading": availableCredit 
    );
}

